import {IHttpClientResponse, THttpMethod} from '../types';

export interface IRequestMeta {
    method: THttpMethod;
    url: string;
}

export class ClientHttpException {
    public readonly status: number;
    public readonly response?: IHttpClientResponse;
    public readonly meta?: IRequestMeta;

    constructor(status: number, response: IHttpClientResponse, meta?: IRequestMeta) {
        this.status = status;
        this.response = response;
        this.meta = meta;
    }

    public get name(): string {
        return 'ClientHttpException';
    }

    public toString(): string {
        return `[${this.name}] :: The requested resource [${this.meta?.method}] ${this.meta?.url} returning ${
            this.status
        } code, response: \n${JSON.stringify(this.response ?? {}, null, 4)}`;
    }
}
